import { getWcBrand } from '../../worldcup/helpers/wcBrand.helper';

export function formatLeagueName(name: string | null | undefined): string {
  if (name == null) return 'Unknown';
  if (name === 'FIFA World Cup') {
    return getWcBrand().NAME;
  }
  return name || 'Unknown';
}
